import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface CircularProgressIndicatorProps {
  isGreen?: boolean
}

const CircularProgressIndicator: React.FC<CircularProgressIndicatorProps> = ({isGreen = false}) => {
  return (
    <div className={styles.spinnerWrapper}>
      <div className={classNames(styles.spinner, {[styles.green]: isGreen})}></div>
    </div>
  );
};

export default CircularProgressIndicator;